// extracted by mini-css-extract-plugin
export var statItem = "_g1-1";
export var statsRow = "_g1-0";